/** Version and build number of the package */
export const VERSION = {version: {major: '9', minor: '0', patch: '10076', branch: 'master'}, build: new Date(1585229427693)};
/** Module name */
export const MODULE = '@acoustic-content-sdk/rest-api';
